import * as React from "react"
import { Skeleton } from "@mui/material"

import { TitleWithPopover, AppTableSeeker } from "@components"
import { WEBBACK_V2_API } from "@constants"
import { useToast, useUserApp } from "@hooks"
import {country, isLoadingCommonFilters} from "@signals"
import { useCatalogueDetailsData } from "./@hooks"
import { mappedColumn, priceColumn, productColumn, productImageColumn, referenceColumn, releaseColumn, retailerColumn, stockColumn } from "./columns"
import CustomMappingToolbarSelect from "./CustomToolbarSelect";


export default function CatalogueDetailsTable() {

	const { showToast } = useToast()
	const { modules } = useUserApp()
    const { tableData } = useCatalogueDetailsData()

	if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={500} />
	if (!tableData.length) return <></>

	const options = {
		onDownload: () => showToast.promiseExcel(`${WEBBACK_V2_API}/catalogue/details/excel`, {country: country.value[0]}),
		customToolbarSelect: (selectedData, setSelectedRows) => (
			<CustomMappingToolbarSelect
				selectedData={selectedData}
				setSelectedRows={setSelectedRows}
			/>
		)
	}

	if (modules.includes("admin")) {
		options.selectableRows = 'multiple';
	}
	return <AppTableSeeker
		data={tableData}
		title={<TitleWithPopover title="Catalogue Analyzer Details" />}
		columns={[
			...retailerColumn(),
			productImageColumn(),
			...productColumn(),
			...(modules.includes("admin") ? mappedColumn() : []),
			...releaseColumn(),
			priceColumn('actualPrice', 'Current Price', true),
			priceColumn('listPrice', 'List Price'),
			priceColumn('shippingPrice', 'Shipping Price'),
			...stockColumn(),
			...referenceColumn()
			
		]}
		options={options}
	/>
}